import axios from 'axios'

export default function (context, val) {
    context.commit('reload');
    context.commit('set_system', {
        tab: 'form',
        type: val.type,
        action: val.action,
    });
    context.commit('set_load', {
        data: true,
    });
    axios({
        method: 'get',
        url: '/tourclient/payment/paymentCatalogsData?_' + new Date().getTime(),
        requestId: 'payment/paymentCatalogsData'
    }).then(d => {
        let subAgent = false, reservationCenter = false;
        if (d.data.IsSettingEnabled) {
            reservationCenter = d.data.IsReservationCenter;
            subAgent = d.data.IsSubAgent;
        }
        context.commit('set_system', {
            IncomePaymentNumber: d.data.IncomePaymentNumber,
            OutcomePaymentNumber: d.data.OutcomePaymentNumber,
            subAgent,
            reservationCenter,
        });
        context.dispatch('create_' + context.state.system.type + '_' + context.state.system.action, val);
    }).catch((error) => {
        context.dispatch('error', {error, text: 'Не удалось получить данные'}, {root: true});
    });
}